import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import bindMethods from 'auto-bind';
import { withTheme } from 'styled-components';

import getOrgById from '../../state/selectors/getOrgById';
import OrgForm from '../../forms/OrgForm';
import FormHeadline from '../../components/form/FormHeadline';
import SSOButton from '../../components/SSOButton';
import { ButtonContainer, HeadlineContainer } from '../../components/form/FormStyles';
import { removeOrgProducts } from '../../state/orgProducts';
import { removeOrgUsers } from '../../state/orgUsers';

class EditOrg extends PureComponent {
  constructor(props) {
    super(props);
    bindMethods(this);
    // this holds an instance of Formik's submitForm function
    this.submitForm = null;
  }

  bindSubmitForm(submitForm) {
    this.submitForm = submitForm;
  }

  handleCancelButtonClick() {
    const {
      history, match, removeOrgProducts, removeOrgUsers,
    } = this.props;
    removeOrgProducts(match.params.id);
    removeOrgUsers();
    return history.goBack();
  }

  handleSubmitForm(event) {
    if (this.submitForm) {
      this.submitForm(event);
    }
  }

  render() {
    const { t, theme, org } = this.props;

    if (!org) {
      return null;
    }

    return (
      <div>
        <HeadlineContainer>
          <FormHeadline
            id="Orgs.Edit.Headline.GeneralInformation"
            headline={t('Pages.Orgs.Headlines.GeneralInformation')}
          />

          <ButtonContainer>
            <SSOButton
              id="Cancel"
              text={t('Shared.General.Cancel')}
              onClick={this.handleCancelButtonClick}
            />
            <SSOButton
              id="Submit"
              text={t('Shared.General.UpdateClose')}
              onClick={this.handleSubmitForm}
              backgroundColor={theme.PRIMARY}
            />
          </ButtonContainer>
        </HeadlineContainer>
        <OrgForm bindSubmitForm={this.bindSubmitForm} org={org} />
      </div>
    );
  }
}

EditOrg.propTypes = {
  history: PropTypes.object.isRequired, // supplied from React Router
  match: PropTypes.object.isRequired, // supplied from React Router
  t: PropTypes.func.isRequired, // supplied from withTranslation
  theme: PropTypes.object.isRequired, // supplied from withTheme
  org: PropTypes.object.isRequired, // supplied from Redux
  removeOrgProducts: PropTypes.func.isRequired, // supplied from Redux
  removeOrgUsers: PropTypes.func.isRequired, // supplied from Redux
};

const mapStateToProps = (state, ownProps) => {
  const { id } = ownProps.match.params;
  return {
    org: getOrgById(state, id),
  };
};

const mapDispatchToProps = {
  removeOrgProducts,
  removeOrgUsers,
};

const TranslatedComponent = withTranslation()(EditOrg);
const ThemedComponent = withTheme(TranslatedComponent);
export default connect(mapStateToProps, mapDispatchToProps)(ThemedComponent);
